// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { setCookie, getCookie } from './assets/js/cookies'
import { initTheme } from './utils/themeUtils'

// 初始化主题（在创建 Vue 实例之前）
initTheme()

// 在main.js引入
// import Vconsole from 'vconsole'
// eslint-disable-next-line no-new
// new Vconsole()

Vue.use(ElementUI)

// Vue.config.errorHandler = (err) => {
//   console.log(err)
// }
Vue.config.productionTip = false
Vue.prototype.$cookie = {
  setCookie,
  getCookie
}

Vue.prototype.$equipment = function () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
   return flag
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js